module.exports = class RefreshSocketClient {

    #hostname;

    #port;

    constructor(hostname = window?.location?.hostname, port = 2083) {

        if (!hostname)
            throw new Error('Host params is required');

        this.#hostname = hostname;
        this.#port = port;
    }

    connect() {

        const ws = new WebSocket(`wss://${this.#hostname}:${this.#port}`);
        ws.addEventListener('open', () => this.log('Connected to dev server'));
        ws.addEventListener('message', (e) => this.onMessageReceivedFromServer(e));
        ws.addEventListener('close', () => this.onServerDisconnected());
    }

    onMessageReceivedFromServer(e) {

        const { data } = e;

        if (data == 'refresh:updated') {

            window.location.reload();
            this.log('updated');
        }
    }

    onServerDisconnected() {

        this.log('Connection lost', 'error');
        this.log('Repeated attempts to connect in 5 seconds', 'error');
        setTimeout(() => this.connect(), 5000);
    }

    log(message, type = 'log') {

        // eslint-disable-next-line no-console
        console[type](`[RefreshSocket] ${message}`);
    }

};